import { useState, useEffect } from 'react';
import { fetchAuthSession } from '@aws-amplify/auth';

export const useUser = () => {
  const [userId, setUserId] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getUser = async () => {
      try {
        const session = await fetchAuthSession();
        const idToken = session.tokens.idToken;
        const sub = idToken.payload.sub; // User ID from Cognito
        const email = idToken.payload.email; // Email from Cognito
        
        if (sub) {
          setUserId(sub);
        }
        
        if (email) {
          setUserEmail(email);
        }
      } catch (error) {
        console.error('Auth error:', error);
        setError(error);
        // Continue without user data for non-authenticated users
      } finally {
        setIsLoading(false);
      }
    };
    getUser();
  }, []);

  return { userId, userEmail, isLoading, error };
};

 